module.exports = __webpack_public_path__ + "img/vessel-error-arrow.83e679b2.svg";